import { UploadDocumentType } from "@src/components/modules/Upload/UploadDocumentType";

export function filterFileTypes(
  files: File[],
  allowedTypes: UploadDocumentType[],
): { allowedFiles: File[]; errorMessage: string } {
  const allowedFiles = files.filter((value) =>
    allowedTypes.includes(value.type as UploadDocumentType),
  );
  if (allowedFiles.length < files.length) {
    const numBadDocs = files.length - allowedFiles.length;
    const str =
      files.length === 1
        ? "File type is not allowed."
        : numBadDocs > 1
        ? `${numBadDocs} of the files are not allowed.`
        : "One of the files is not allowed.";
    return {
      allowedFiles: [],
      errorMessage: str,
    };
  }
  return {
    allowedFiles,
    errorMessage: "",
  };
}
